import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'hiddenInput'];
  static values = { length: Number };

  connect() {
    this.clearInputs();
    this.inputTargets[0].focus();
  }

  clearInputs() {
    this.inputTargets.forEach((input) => (input.value = ''));
    this.hiddenInputTarget.value = '';
    this.updateBorders();
  }

  paste(event) {
    event.preventDefault();
    const pasteData = (event.clipboardData || window.clipboardData)
      .getData('text')
      .trim();
    const digits = pasteData
      .replace(/\D/g, '')
      .slice(0, this.lengthValue)
      .split('');

    this.clearInputs();

    digits.forEach((digit, index) => {
      if (this.inputTargets[index]) {
        this.inputTargets[index].value = digit;
      }
    });

    const nextIndex =
      digits.length < this.lengthValue ? digits.length : this.lengthValue - 1;
    this.inputTargets[nextIndex].focus();
    this.updateHiddenInput();
    this.updateBorders();
  }

  input(event) {
    const input = event.target;
    const index = parseInt(input.dataset.index, 10);

    input.value = input.value.replace(/\D/g, '');

    if (input.value && index < this.lengthValue - 1) {
      this.inputTargets[index + 1].focus();
    }

    this.updateHiddenInput();
    this.updateBorders();
  }

  keydown(event) {
    const input = event.target;
    const index = parseInt(input.dataset.index, 10);

    if (event.key === 'Backspace' && !input.value && index > 0) {
      this.inputTargets[index - 1].focus();
    }

    this.updateBorders();
  }

  updateHiddenInput() {
    this.hiddenInputTarget.value = this.inputTargets
      .map((i) => i.value)
      .join('');
  }

  updateBorders() {
    this.inputTargets.forEach((input) => {
      const hasValue = input.value !== '';
      input.classList.toggle('border-dark', hasValue);
      input.classList.toggle('border-neutral-400', !hasValue);
    });
  }
}
